import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createFlagBadge } from '@vfde-brix/ws10/flag-badge';
import { FLAG_BADGE_BASE_CLASSNAME } from '@vfde-brix/ws10/flag-badge/Constants';
createComponents(".".concat(FLAG_BADGE_BASE_CLASSNAME), createFlagBadge, NO_PATTERN_BUSINESS_LOGIC);
